import {observable} from 'mobx';
import {construct, createArrayInstance, createInstance, ModelProperties} from '../utils';
import {OfferPage} from './offer-page';
import {OfferProductLocaleContent} from './offer-product-locale-content';

export class OfferProduct {
    @observable id!: number;

    @observable productCode!: string;

    @observable discountCode!: string;

    @observable discountNumber!: string;

    @observable discountNumberDisplayed!: string;

    @observable premiumLogo!: boolean;

    @observable order!: number;

    @observable pageId!: number;

    @observable page?: OfferPage;

    @observable content?: OfferProductLocaleContent[];

    constructor(product?: ModelProperties<OfferProduct>) {
        if (product) {
            construct(this, product);
            this.page = createInstance(OfferPage, product.page);
            this.content = createArrayInstance(OfferProductLocaleContent, product.content);
        }
    }
}
